import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';

import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';

class Warninable extends Component {
    state = {
        minimun: this.props.value && this.props.value.inferior ? this.props.value.inferior : '',
        minimunlimit:
            this.props.value && this.props.value.limiteinferior
                ? this.props.value.limiteinferior
                : false,
        maximun: this.props.value && this.props.value.superior ? this.props.value.superior : '',
        maximunlimit:
            this.props.value && this.props.value.limitesuperior
                ? this.props.value.limitesuperior
                : false,
    };

    static getDerivedStateFromProps(props, state) {
        const { type, blocked } = props;
        if (type !== state.type && blocked !== state.blocked) {
            state.type = type;
            state.minimun = props.value && props.value.inferior ? props.value.inferior : '';
            state.minimunlimit =
                props.value && props.value.limiteinferior ? props.value.limiteinferior : false;
            state.maximun = props.value && props.value.superior ? props.value.superior : '';
            state.maximunlimit =
                props.value && props.value.limitesuperior ? props.value.limitesuperior : false;
            state.blocked = blocked;
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        let { minimun, maximun, maximunlimit, minimunlimit } = this.state;
        switch (event.target.name) {
            case 'minimun':
                minimun = event.target.value;
                break;
            default:
                maximun = event.target.value;
                break;
        }
        this.props.onChange({
            inferior: minimun,
            limiteinferior: minimunlimit,
            superior: maximun,
            limitesuperior: maximunlimit,
        });
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        let { minimun, maximun, maximunlimit, minimunlimit } = this.state;
        const value = event.target.value === 'true';
        switch (event.target.name) {
            case 'minimunlimit':
                minimunlimit = value;
                break;
            default:
                maximunlimit = value;
                break;
        }
        this.props.onChange({
            inferior: minimun,
            limiteinferior: minimunlimit,
            superior: maximun,
            limitesuperior: maximunlimit,
        });
        this.setState({ [event.target.name]: value });
    };

    render() {
        const { minimun, maximun, maximunlimit, minimunlimit, blocked } = this.state;
        const { intl, disabled } = this.props;
        return (
            <div className={'flex_full_row align_center margin_top_12'}>
                <div className={'flex_full_row center'}>

                    <Radio
                        disabled={!minimun || disabled}
                        name={'minimunlimit'}
                        checked={minimunlimit.toString() === 'true'}
                        onChange={this.handleChecked}
                        value={'true'}
                        aria-label=">="
                    />
                    <span className={'barlow_regular_message'}>{'>='}</span>
                    <Radio
                        disabled={!minimun || blocked || disabled}
                        name={'minimunlimit'}
                        checked={minimunlimit.toString() === 'false'}
                        onChange={this.handleChecked}
                        value={'false'}
                        aria-label=">"
                    />
                    <span className={'barlow_regular_message'}>{'>'}</span>
                    <TextField
                        name="minimun"
                        label={intl.formatMessage({
                            id: minimunlimit
                                ? 'form_field_warningable_greater_equal_than'
                                : 'form_field_warningable_greater_than',
                        })}
                        className={'margin_left_12 margin_top_0 flex_full_row'}
                        value={minimun}
                        onChange={this.handleChange}
                        margin="normal"
                        type="number"
                        error={
                            maximun !== undefined &&
                            minimun !== undefined &&
                            parseInt(maximun, 10) < parseInt(minimun, 10)
                        }
                        helperText={
                            maximun && minimun && parseInt(maximun, 10) < parseInt(minimun, 10)
                                ? intl.formatMessage({ id: 'error_range' })
                                : ''
                        }
                        disabled={disabled}
                    />
                </div>
                <div className={'flex_full_row center'}>
                    <TextField
                        name="maximun"
                        label={intl.formatMessage({
                            id: maximunlimit
                                ? 'form_field_warningable_less_equal_than'
                                : 'form_field_warningable_less_than',
                        })}
                        className={'margin_left_12 margin_top_0 flex_full_row'}
                        value={maximun}
                        type="number"
                        onChange={this.handleChange}
                        margin="normal"
                        disabled={disabled}
                    />
                    <Radio
                        disabled={!maximun || blocked || disabled}
                        name={'maximunlimit'}
                        checked={maximunlimit.toString() === 'false'}
                        onChange={this.handleChecked}
                        value={'false'}
                        aria-label="<"
                    />
                    <span className={'barlow_regular_message'}>{'<'}</span>
                    <Radio
                        disabled={!maximun || disabled}
                        name={'maximunlimit'}
                        checked={maximunlimit.toString() === 'true'}
                        onChange={this.handleChecked}
                        value={'true'}
                        aria-label="<="
                    />
                    <span className={'barlow_regular_message'}>{'<='}</span>

                </div>

            </div>
        );
    }
}

Warninable.propTypes = {
    intl: intlShape.isRequired,
};

Warninable = injectIntl(Warninable);

export default Warninable;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Warninable.js